Pluswerk.PlusProject.Form = {};

/**
 * FormController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Form.FormController = function () {
  var showSpinner = function ($formObject) {
    if (!$formObject.find('div.spinner').length) {
      $formObject.find($('input[type="submit"]:not(.noSpinner), button[type="submit"]:not(.noSpinner)')).removeClass('changed').addClass('hide')
      .after('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>');
    }
  };

  var hideSpinner = function ($formObject) {
    if ($formObject.find('div.spinner').length) {
      $formObject.find($('input[type="submit"]:not(.noSpinner), button[type="submit"]:not(.noSpinner)')).addClass('changed').removeClass('hide').after('');
    }
  };

  var getLanguage = function () {
    var pageLanguage = $('html').attr('lang');
    if (pageLanguage === 'fa') {
      // we have no translations for farsi yet, so return english for now
      return 'en';
    } else {
      return pageLanguage;
    }
  };

  var initializeDatepicker = function () {
    $('.js-datepicker').each(function () {
      $(this).flatpickr({
        dateFormat: 'Y-m-d\\T00:00:00\\+00:00',
        altInput: true,
        altFormat: $(this).data('format'),
        locale: getLanguage(),
        allowInput: true
      });
    });
  };

  var setProgressBar = function () {
    $('.js-form').each(function () {
      var $form = $(this);
      var currentIndex = $form.data('currentindex');
      var $progressBar = $form.find('.js-progressBar');
      if ($progressBar.length) {
        var $formHeader = $form.find('.js-formHeader');
        var $headerElements = $form.find('.js-formHeaderElement');
        var offsetLeft = $headerElements[currentIndex].offsetLeft;
        var elementWidth = $headerElements[currentIndex].offsetWidth;
        var headerWidth = $formHeader[0].offsetWidth;
        /* calculate width in pixel of progressBar */
        var progressBarLengthPixel = offsetLeft + (elementWidth / 2);
        /* calculate percentage width of progressBar */
        var progressBarLengthPercent = (progressBarLengthPixel / headerWidth) * 100;
        $progressBar.attr('style', 'width: ' + progressBarLengthPercent + '%');
      }
    });
  };

  initializeDatepicker();
  setProgressBar();

  $('form').on('submit', function (e) {
    if (Pluswerk.PlusProject.Utility.ValidateFormController.isFormSubmittable($(this))) {
      showSpinner($(this));
    } else {
      e.preventDefault();
      e.stopPropagation();
      $(this)[0].reportValidity();

      // scroll to first error element
      var $firstInvalidElement = $('form .error').first();
      if ($firstInvalidElement.length) {
        if ($firstInvalidElement.offset() && $firstInvalidElement.offset().top) {
          $([document.documentElement, document.body]).animate({
            scrollTop: $firstInvalidElement.offset().top - 100,
          }, 400);
        }
      }
    }
  });

  // @todo: this is a copy of: web/typo3conf/ext/plus_project/Resources/Public/JavaScript/InlineFooter.js
  var figures = document.getElementsByTagName("FIGURE");
  var attachImagesFromFigures = function () {
    for (var i = 0; i < figures.length; i++) {
      if (typeof figures[i].dataset !== 'undefined' && !isElementHidden(figures[i], 'image--hideOnMobile')) {
        if (figures[i].dataset.img) {
          var a = figures[i].getElementsByTagName("A");
          if (a.length) {
            a[0].innerHTML = figures[i].dataset.img;
          } else {
            figures[i].innerHTML = figures[i].dataset.img;
          }
          delete figures[i].dataset.img;
        }
      }
    }
    // window.removeEventListener('resize', attachImages);
  };
  var isElementHidden = function (element, cls) {
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (w > 767) {
      return false;
    } else {
      return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }
  };
};
